import { Component } from '@theme/component';

class HalvaQuantity extends Component {
  #controller;
  #form;
  #select;
  #native;

  async connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const signal = this.#controller.signal;
    this.#form = this.closest('form');
    this.#select = this.querySelector('[data-halva-preset]');
    if (!this.#form || !this.#select) return;
    if (this.dataset.mode === 'pdp') {
      await customElements.whenDefined('quantity-selector-component');
      if (!this.isConnected || signal.aborted) return;
      this.#native = this.#form.querySelector('quantity-selector-component');
      if (!this.#native?.setValue || !this.#native?.getValue) return;
      this.#select.value = ['1', '4', '10'].includes(this.#native.getValue()) ? this.#native.getValue() : '1';
    }
    this.#select.addEventListener('change', () => this.#sync(), { signal });
    this.#sync();
    this.hidden = false;
    this.dataset.ready = '';
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #sync() {
    const value = this.#select.value;
    if (!['1', '4', '10'].includes(value)) return;
    if (this.#native) {
      this.#native.setValue(value);
      this.#native.onQuantityChange();
      this.#native.updateButtonStates();
    }
    const formComponent = this.#form.closest('product-form-component');
    if (formComponent) formComponent.dataset.quantityDefault = value;
    this.dataset.selectedQuantity = value;
    this.querySelector('[data-halva-total]').textContent = this.#select.selectedOptions[0].dataset.money;
  }
}

if (!customElements.get('upupa-halva-quantity')) customElements.define('upupa-halva-quantity', HalvaQuantity);
